<div
  mat-button
  class="tile"
  fxLayout="column"
  fxLayoutAlign="space-between none"
>
  <div class="tile-content">
    <h4 class="m-0 template-name">{{ emailTemplate.templateName }}</h4>
    @if (emailTemplate.isDefault) {
      <div class="default-tag">
        <span class="lineup-tag">Default</span>
      </div>
    }
    <div class="email-preview">
      <p class="subject-line mb-0">{{ emailTemplate.subject }}</p>
      <p [innerHtml]="emailTemplate.content | safeHtml"></p>
    </div>
  </div>
  <div class="tile-actions" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="primary-actions" fxLayout="row">
      <preview-template-message
        [templateName]="getMandrillEmailTemplateTypeForPreview()"
        [subject]="this.emailTemplate.subject"
        [fromName]="this.emailTemplate.contactName"
        [replyTo]="this.emailTemplate.contactEmail"
        [content]="this.emailTemplate.content"
        [buttonText]="this.emailTemplate.buttonText"
        [link]="this.emailTemplate.buttonLink"
      >
      </preview-template-message>
      <button class="lineup-button" mat-button (click)="onEdit()">Edit</button>
    </div>
    <button
      [attr.data-testid]="emailTemplate.templateName"
      mat-icon-button
      [matMenuTriggerFor]="moreActions"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #moreActions="matMenu">
      @if (
        emailTemplate.scenario !== 'TeamEmail' &&
        emailTemplate.scenario !== 'GeneralEmail'
      ) {
        <button
          mat-menu-item
          (click)="setDefault()"
          [disabled]="emailTemplate.isDefault"
        >
          <span>Set as default</span>
        </button>
      }
      <button mat-menu-item (click)="onClone()">
        <span>Clone template</span>
      </button>
      @if (hasOwnerRole()) {
        <button
          mat-menu-item
          (click)="delete()"
          [disabled]="emailTemplate.isDefault"
        >
          <span [ngClass]="{ 'warning-color': !emailTemplate.isDefault }"
            >Delete template</span
          >
        </button>
      }
    </mat-menu>
  </div>
</div>
